export default {
  userCS(state) {
    return state.userCS;
  },
  consumerUnits(state) {
    return state.consumerUnits;
  },
  consumerUnitsOpened(state) {
    return state.consumerUnitsOpened;
  },
  consumerUnit(state) {
    return state.consumerUnit;
  },
  userCSNotFound(state) {
    return state.userCSNotFound;
  },
  userCSError(state) {
    return state.userCSError;
  },
  billings(state) {
    return state.billings;
  },
  filteredBillings(state) {
    return state.billings.filter(
      (b) =>
        b.status !== "paid" &&
        b.status !== "succeeded" &&
        b.status !== "free" &&
        b.status !== "parceled" &&
        !b.negotiation,
    );
  },
  specialBillings(state) {
    return state.specialBillings;
  },
  billing(state) {
    return state.billing;
  },
  history(state) {
    return state.history;
  },
  observation(state) {
    return state.observation;
  },
  observations(state) {
    return state.observations;
  },
  task(state) {
    return state.task;
  },
  tasks(state) {
    return state.tasks;
  },
  tasksByDepartament(state, departament) {
    return state.tasks.filter((task) => {
      if (task.departament === departament) return task;
    });
  },
  tasksByUser(state, user_id) {
    return state.tasks.filter((task) => {
      if (task.user_id === user_id) return task;
    });
  },
  agents(state) {
    return state.agents;
  },
  activities(state) {
    return state.activities;
  },
  cards(state) {
    return state.cards;
  },
  negativations(state) {
    return state.negativations;
  },
  hasNegativationActive(state) {
    if (state.negativations) {
      let activities = state.negativations.filter(
        (neg) => neg.status !== "removed",
      );
      if (activities.length > 0) return true;
      else return false;
    } else {
      return false;
    }
  },
  NegativationActiveList(state) {
    if (state.negativations) {
      return state.negativations.filter((neg) => neg.status !== "removed");
    } else {
      return [];
    }
  },
  hasNegativationNotPaid(state) {
    if (state.negativations) {
      let paid = state.negativations.filter((neg) => neg.status !== "paid");
      if (paid.length > 0) return true;
      else return false;
    } else {
      return false;
    }
  },
  billingsById: (state) => (id) => {
    return state.billings.find((billing) => billing.id == id);
  },
  provisionedBillings: (state) => {
    return state.provisionedBillings.filter(
      (bill) => bill.rebate_status !== "canceled",
    );
  },
};
